import request from 'utils/request'
import {stringify} from 'qs'
import api from './api'

// 员工任务统计列表
export async function getStaffTaskStatList(payload) {
    return request(`${api.getStaffTaskStatList.url}?${stringify(payload)}`)
}

export async function exportData(params) {
    return request(`${api.exportData.url}${stringify(params, {addQueryPrefix: true})}`, null, {
        returnResponse: true,
    })
}
